import { Stack, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

export interface UserMessageBubbleProps {
  content: string;
}

export function UserMessageBubble({ content }: UserMessageBubbleProps) {
  return (
    <Stack
      data-testid="chat-user-message-bubble"
      sx={{
        backgroundColor: COLORS.NAVY[50],
        border: `1px solid ${COLORS.NAVY[100]}`,
        borderRadius: '16px',
        px: 2,
        py: 1.5,
        maxWidth: '80%',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        alignSelf: 'flex-end',
      }}
    >
      <Typography
        variant="body-xs"
        sx={{
          fontWeight: 500,
          color: COLORS.TEXT.PRIMARY,
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
        }}
      >
        {content}
      </Typography>
    </Stack>
  );
}
